module.exports = __webpack_public_path__ + "img/logo.622eaab0.svg";